
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    icon: {
        marginRight: '5px'
    },
    button: {
        padding: '1px 5px',
        fontSize: '9px',
        lineHeight: 1.5,
        borderRadius: '3px',
        color: 'rgba(255, 255, 255, 0.96)',
        background: 'rgba(4, 3, 3, 0.33)',
        float: 'left',
        textTransform: 'none',
        marginRight: '4px',
        marginBottom: '4px',
        boxShadow: '0 1px 1px rgba(128, 128, 128, 0.2)',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        fontWeight: 500,
        textAlign: 'center',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        display: 'inline-block',
        border: 0,
        cursor: 'pointer',
        outline: 'none'
    },
    configurationButtonChecked: {
        background: 'rgba(255, 107, 2, 0.79)'
    },
    attButtonChecked: {
        background: 'rgba(5, 226, 68, 0.79)'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/AdminControls/AdminButton/styles.js